import React from 'react';
import { useTranslation } from 'react-i18next';

import { EiqInput } from 'eiq-storybook';
import s from './CapboxHeadernew.styles';

function CapboxHeader({ site, setFieldValue, setIsDirty, clientId, setClientId, errors, disableClientId }) {
  const { t } = useTranslation();

  return <>
  <s.CapHeader>
    <s.CapHeaderTitle>{t('SITE_INFORMATION')}</s.CapHeaderTitle>

    <s.CapHeaderTable>
      <s.CapHeaderColumn head>
        <span>{t('SITE_NAME_ENGLISH')}</span>
        <span>{site.name}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('SITE_NAME_LOCAL_LANGUAGE')}</span>
        <span>{site.localName}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('COUNTRY')}</span>
        <span>{site.country}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('ADDRESS')}</span>
        <span>{site.address}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('COLUMN_REPORT_NUMBER')}</span>
        <span>{site.reportNumber}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <s.CapHeaderFieldLabel for="clientId">{t('CLIENT_ID')}</s.CapHeaderFieldLabel>
        <EiqInput id="clientId"
                  disabled={disableClientId} 
                  data-testid="clientId"
                  placeholder={t('CLICK_HERE_TO_ENTER_TEXT')} 
                  required 
                  type="text"
                  defaultValue={clientId || ''}
                  errorMessage={errors.clientId}
                  onBlur={(e) => {
            setFieldValue('clientId', e.target.value)
            setClientId(e.target.value);
          }}
                  onChange={(e) => setIsDirty(true)}
        />
      </s.CapHeaderColumn>
    </s.CapHeaderTable>
  </s.CapHeader></>;
}

export { CapboxHeader };
